import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlUtilityService } from '../ll-utility.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';

@Component({
  selector: 'll-model-cash',
  templateUrl: './ll-model-cash.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlModelCashComponent implements OnInit {

  @ViewChild('mainDiv_ll_model_cash') private mainDiv: ElementRef;
  @ViewChild('datagrid_ll_model_cash') datagrid!: jqxGridComponent;
  constructor(
    private LlModelsService: LlModelsService,
    private LlPermissionsService: LlPermissionsService,
    private LlUtilityService: LlUtilityService,
  ) { }

  bundle = {
    showDisplay: false,
    showGraph: false,
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    showHorzTabs: false,
    showRemaining: false,
    showGrid: false,
    showSelectAll: false,
    allSelected: false,
    mode: '',
    function: '',
   
    gridX: 0,
    gridY: 50,
    gridW: 0,
    gridH: 0,
    showTab: true,
    horzTabsY: 20,
    hTabW: 120,
    hTabH: 15,
    hTabIndent: 50,
    hTabIndx: 0,
    horzTabs: [],
    //bankTabs: [],
    //remitTabs: [],
    canvasHT: {},
    ctxHT: {},
    activeCODE: "List",
    monthList: [] as any[],
    locationList: [] as any[],
    records: [] as any[],
    columns: [] as any[],
    activeRowIndex: 0,
    newUSERNOTE: '',
    newCASHUSERCHOICEID: 0,
    newCashBankLocationAccountId: 0,
    selectedRecords: [] as any[],
    monthChoice: '',
    locationIdChoice: 0,
    stateIdChoice: 0,
    divisionIdChoice: 0,
    fileLabel: '',
  }

  ngOnDestroy() { }
  ngOnInit() { }

  ngAfterViewInit() {
    this.setVars();
  }

  calculateGridYLocation(offSet) {
    this.bundle.remainingY = this.bundle.horzTabsY + this.bundle.hTabH + offSet
    this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;
    this.bundle.gridH = this.bundle.remainingH - 45;
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingX = 0;
      this.bundle.remainingW = this.bundle.parentW;;
      this.bundle.gridW = this.bundle.remainingW;

      this.calculateGridYLocation(70);
      this.getData()
    });
  }


  getData() {

    this.bundle.activeCODE = "Remaining";

    this.bundle.horzTabs.push({ LABEL: "Remaining", CODE: "Remaining" });
    this.bundle.horzTabs.push({ LABEL: "Ruled In to Reconcile", CODE: "NOT_Reconciled" });
    this.bundle.horzTabs.push({ LABEL: "Ruled Out", CODE: "Filtered_Out" });

    this.LlModelsService.NG_LL_model_AR_cash_resetActiveSettings()

    this.LlModelsService.NG_LL_model_AR_cash_monthList_get((arr: any[]) => {

      this.bundle.monthList = arr || [];

      //console.log(this.bundle.monthList);

      this.bundle.monthList.unshift({
        CHOICE: "1900^00",
        LABEL: "All"
      });


      this.bundle.monthChoice = this.bundle.monthList[1].CHOICE;

      this.LlModelsService.NG_LL_model_AR_cash_list_location_get((arr: any[]) => {

        this.bundle.locationList = arr || [];

        this.getGridData();

        this.bundle.showHorzTabs = true;
        this.bundle.showRemaining = true;


      });


    });

  }

  

  getGridData() {

    this.bundle.showGrid = false;
    this.bundle.showSelectAll = false;


    this.LlModelsService.NG_LL_model_AR_cash_reconcileData_get(
      (arr: any[]) => {
        this.bundle.records = arr || [];
        this.paintGrid();
      },
      this.bundle
    );
  };

  paintGrid(): void {

    //console.log(this.bundle.records)

    if (!this.datagrid) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintGrid(), 100);
      return;
    }

    var fields = [];
    var columns = [];
    let colW01 = 70;
    let colW02 = 70;
    let colW03 = 100;
    let colW04 = 75;
    let colW05 = 100;
    let colW06 = 70;
    let colW07 = 100;
    let colW08 = 50;
    let colW09 = 100;
    let colW10 = 0;
    let colW11 = 0;
    let colW12 = 0;
    let colW13 = 0;

    let remainingW = this.bundle.gridW - colW01 - colW02 - colW03 - colW04 - colW05 - colW06 - colW07 - colW08 - colW09 - colW10 - colW11 - colW12 - colW13;

    /*if (this.LlPermissionsService.check("reconcileCash")) {*/

      //if (this.bundle.activeCODE.toLowerCase() === 'not_reconciled' || this.bundle.activeCODE.toLowerCase() === 'reconciled') {
      //  columns.push({ text: 'Recon.', datafield: 'RECONCILED', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      //  remainingW = remainingW - 70;
      //}

      //if (this.bundle.activeCODE.toLowerCase() === 'not_reconciled') {
      //  columns.push({ text: 'Rule Out', datafield: 'rule_out', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      //  remainingW = remainingW - 70;
      //}
    /*}*/

    if (this.bundle.activeCODE.toLowerCase() === 'not_reconciled') {
      columns.push({ text: 'Rule Out', datafield: 'rule_out', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      remainingW = remainingW - 70;
    }

    if (this.bundle.activeCODE.toLowerCase() === 'remaining' && this.LlPermissionsService.check("reconcileCash")) {
      columns.push({ text: 'Rule Out', datafield: 'rule_out', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      remainingW = remainingW - 70;


      columns.push({ text: 'Rule In', datafield: 'rule_in', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      remainingW = remainingW - 70;

    }

    if (this.bundle.activeCODE.toLowerCase() === 'filtered_out' && this.LlPermissionsService.check("reconcileCash")) {
      columns.push({ text: 'Rule In', datafield: 'rule_in', columntype: 'checkbox', width: 70, editable: true, align: 'center' });

      remainingW = remainingW - 70;

    }


    if (this.bundle.activeCODE.toLowerCase() === 'remaining' && this.LlPermissionsService.check("editCashLogic")) {
      columns.push({ text: 'Rule', datafield: 'EDIT', cellsrenderer: editGear, width: 50, editable: false, align: 'center' });

      remainingW = remainingW - 50;
    }


    columns.push({ text: 'TransID', datafield: 'CASHFROMBANKID', columntype: 'string', width: colW01, editable: true, dataType: 'string', });
    columns.push({ text: 'Bank', datafield: 'SENDERNAME', columntype: 'string', width: colW02, editable: true, dataType: 'string', });
    columns.push({ text: 'Location', datafield: 'RECIPIANTNAME', columntype: 'string', width: colW03, editable: false, dataType: 'string', });
    columns.push({ text: 'Location ID', datafield: 'RECIPIANTIDNUMBER', columntype: 'string', width: colW04, editable: false, dataType: 'string', });
    columns.push({ text: 'Date', datafield: 'ENTRYDATE_TXT', columntype: 'string', width: colW05, editable: false, dataType: 'string', });
    columns.push({ text: 'Type', datafield: 'ENTRYTYPE', columntype: 'string', width: colW06, editable: false, dataType: 'string', });
    columns.push({ text: 'Amount', datafield: 'ENTRYAMOUNT', columntype: 'string', width: colW07, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
    columns.push({ text: 'Code', datafield: 'ENTRYCODE', columntype: 'string', width: colW08, editable: false, dataType: 'string', });
    columns.push({ text: 'Description', datafield: 'ENTRYDESCRIPTION', columntype: 'string', width: colW09, editable: false, dataType: 'string', });
    columns.push({ text: 'Detail', datafield: 'ENTRYDETAIL', columntype: 'string', width: 500, editable: false, dataType: 'string', });

    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];

      if (col.dataType === 'float') {
        // Ensure 2 decimal places for every float column
        col.cellsformat = 'f2';
        col.cellsalign = 'right';        // good UX for numbers

        fields.push({
          name: col.datafield,
          type: 'number'
        });
      } else {
        fields.push({
          name: col.datafield,
          type: 'string'
        });
      }

    }



    this.bundle.columns = columns;

    setTimeout(() => {
      const source = { localdata: this.bundle.records, datatype: 'array', fields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.datagrid.source(dataAdapter);
      this.datagrid.columns(columns);
      this.datagrid.width(this.bundle.gridW);
      this.datagrid.height(this.bundle.gridH);
      this.datagrid.updatebounddata();

      this.datagrid.refresh();
      this.datagrid.render();

    }, 0);

    this.bundle.showGrid = true;

    function editGear(row: number, column: any, value: string) {
      var img = '<div class="editGear" [id]="EDIT" height:18px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

      return img;
    }

    function notePencil(row: number, column: any, value: string) {
      var img = '<div  class="notePencil" [id]="NOTE" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_pencil.png" ></div>';

      return img;
    }

  }


  clickOnRow(event: any): void {

    console.log("clickOnRow")

    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;

    if (this.LlPermissionsService.check("editCashLogic")) {


      if (this.bundle.activeCODE.toLowerCase() == 'remaining') {

        if (dataField === "rule_out") {

          let ruleInVal = this.datagrid.getcellvalue(rowIndex, 'rule_in');

          if (newValue == true) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_OUT');

            if (ruleInVal === true) {
              this.datagrid.setcellvalue(rowIndex, 'rule_in', false);
            }
          } else if (newValue == false && ruleInVal === false) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'ADDBACK');

          }


        } else if (dataField === "rule_in") {

          let ruleOutVal = this.datagrid.getcellvalue(rowIndex, 'rule_out');

          if (newValue == true) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_IN');

            if (ruleOutVal === true) {
              this.datagrid.setcellvalue(rowIndex, 'rule_out', false);
            }

          } else if (newValue == false && ruleOutVal === false) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'ADDBACK');

          }
        } else {
          this.LlModelsService.cashLogic_edit_mode(this.bundle.records[rowIndex].CASHFROMBANKID, 0);
        }

      } else if (this.bundle.activeCODE.toLowerCase() == 'filtered_out') {
        if (newValue == true) {
          this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_IN');

        } else if (newValue == false) {
          this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_OUT');
        }

      } else if (this.bundle.activeCODE.toLowerCase() == 'not_reconciled') {


        if (dataField === "rule_out") {
          if (newValue == true) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_OUT');

          } else if (newValue == false) {
            this.LlModelsService.NG_LL_model_AR_cash_removeTransaction_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'RULE_IN');
          }
        }

      } 
    } 
  }

  selectTab(code) {
    this.bundle.showHorzTabs = false;
    this.bundle.activeCODE = code;
    this.getGridData();
  }

  onMonthChange(event: any): void {
    const newCHOICE = event.target.value;

    this.LlModelsService.setRECONMONTHCHOICE(newCHOICE);

    setTimeout(() => {
      this.getGridData()
    });
  }

  onLocationChange(event: any): void {
    const newLocationId = event.target.value;
    this.LlModelsService.setLOCATIONID_ACTIVE(newLocationId)

    setTimeout(() => {
      this.getGridData()
    });
  }

  exportOnClick() {

    let label = this.bundle.activeCODE;

    for (let k = 0; k < this.bundle.columns.length; k++) {

      this.bundle.columns[k].STUDYCOLUMNQUESTIONIDALPHA = this.bundle.columns[k].datafield;
      this.bundle.columns[k].STUDYCOLUMNLABEL = this.bundle.columns[k].text
      this.bundle.columns[k].SYSTEMORGANIZATIONFIELDCODE = this.bundle.columns[k].datafield
    }

    var rows = this.datagrid.getdisplayrows();

    this.LlUtilityService.saveCSV(rows, this.bundle.columns, label)

  };

}
